import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";
import auth from "../../auth";
import axios from "axios";
import InputMask from 'react-input-mask';

import Datetime from 'react-datetime';

import { Table, Nav, NavItem, NavLink, Row, Button, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"


class ModalHistorico extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitudes: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            solicitudes: [],
        })
    }
    
    getData(){
        const { solicitudes} = this.state;

        return {solicitudes}
    }

    setSelects(data) {

    }

    onValidation(){
        const { solicitudes} = this.state;

        if(solicitudes.length>0){
            return true;
        }

        return false;
    }

    onOpen = () => {
        let selectedRows = this.props.rows();
        if(selectedRows.length>0){
            let solicitudes = [];
            selectedRows.forEach((row)=>{
                solicitudes.push(row.plan__solicitud_id);
            })
            this.setState({
                solicitudes: solicitudes,
            })
        }
    }


    render() {
        const { solicitudes } = this.state;
        return (
            <ParadigmaModal
                postUrl={api.proyectos.solicitudes.habilitarhistoricos}
                onSubmit={(e) => {this.props.onSubmit(e)}}
                multiSelectIDs={this.props.multiSelectIDs()}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Habilitar Proyectos Historicos"}
                saveButtonLabel={"Confirmar"}
                buttonTitle={"Habilitar Proyectos Historicos"}
                // buttonIcon={"fa fa-history fa-lg"}
                buttonIcon={"fa fa-outdent fa-lg"}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}
                onOpen={() => this.onOpen()}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                multiselect={true}
                backdropToggle={true}
            >
                {this.props.multiSelectIDs() ? 
                <Fragment>
                    <Row>
                        <Col className={'col-12 mt-2 mb-3'}>
                            <div className={"table-historico"}>
                                <Table className="table-sm">
                                        <thead>
                                            <tr>
                                                <th>Codigo</th>
                                                <th>Nombre</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.rows().map((e, i)=>
                                            <tr key={i}>
                                                <td>
                                                    {(e.plan__solicitud__codigo) ? (e.plan__solicitud__codigo) : ''}
                                                </td>
                                                <td>
                                                    {(e.plan__solicitud__nombre) ? (e.plan__solicitud__nombre) : ''}
                                                </td>
                                            </tr>)}
                                        </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                    {/*<Row>
                        <Col className={'col-12 text-center'}>
                            <Label className="display-inline-block">Habilitar proyectos</Label>
                        </Col>
                    </Row>*/}
                </Fragment>
                :
                <Row>
                    <Col className={'col-12 text-center'}>
                        <h3>Debe seleccionar una fila.</h3>
                    </Col>
                </Row>
                }
            
            </ParadigmaModal>
        );
    }
}

export default ModalHistorico;



// WEBPACK FOOTER //
// ./src/views/ProyectosHistoricos/ModalHistorico.js